import { observer } from 'mobx-react';
import React from 'react';

import DrawerButton from 'components/Views/Creative/Drawers/DrawerButton';
import type Bundle from 'stores/Bundle';

import BundleReportModal from './BundleReportModal';

export interface BundleReportButtonProps {
  bundle: Bundle;
}

function BundleReportButton({ bundle }: BundleReportButtonProps) {
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const showModal = () => {
    if (!bundle.elements.mounted) {
      void bundle.elements.load();
    }
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <DrawerButton disabled={bundle.loading} onClick={showModal}>
        Details
      </DrawerButton>

      <BundleReportModal
        bundle={bundle}
        isVisible={isModalVisible}
        onClose={hideModal}
      />
    </>
  );
}

export default observer(BundleReportButton);
